import React from 'react';
import { connect } from 'react-redux';

import MenuItemChoiceSelection from '../../common/menuitem/MenuItemChoiceSelection';

import { cartItemLoadSpecialItems } from '../../../actions/cartItem';
import generateSpecialItem from '../../../utils/generateSpecialItem';
import { setSpecialPanel } from '../../../actions/panels';

class ViewItemChoices extends React.Component {

    updateSpecialItemChoice(theItem) {

        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex && theCartItem.id != theItem.id) {

                return generateSpecialItem(theItem);
            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    render() {

        return (
            <div className="menu-item-window menu-item-list">
                {this.props.special.items[this.props.index].choices.map((item) => (
                    <MenuItemChoiceSelection
                        onChoicePress={() => { 
                            this.updateSpecialItemChoice(item);
                            this.props.updateSpecialItem(item);

                            // send to the appropriate link
                            if (item.custom_pizza_id) {
                                this.props.dispatch(setSpecialPanel('custom_pizza'));
                            }
                            else if (item.pizza_id) {
                                this.props.dispatch(setSpecialPanel('pizza'));
                            }
                            else if (item.food_item_id) {
                                this.props.dispatch(setSpecialPanel('food_item'));
                            }
                            else if (item.beverage_id) {
                                this.props.dispatch(setSpecialPanel('info'));
                            }
                        }}
                    >
                        {item.display_name}
                    </MenuItemChoiceSelection>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        special: state.currentMenuItem.item,
        cartItem: state.cartItem
    };
};


export default connect(mapStateToProps)(ViewItemChoices);
